import request from '../utils/request';

export const getUserArticleRedeemList = (queryDTO = {}) => {
  return request({
    url: '/user-article-redeem/list',
    method: 'post',
    data: queryDTO
  });
};

export const getUserArticleRedeemById = (id) => {
  return request({
    url: `/user-article-redeem/${id}`,
    method: 'get'
  });
};

export const createUserArticleRedeem = (data) => {
  return request({
    url: '/user-article-redeem',
    method: 'post',
    data
  });
};

export const updateUserArticleRedeem = (id, data) => {
  return request({
    url: `/user-article-redeem/${id}`,
    method: 'put',
    data
  });
};

export const deleteUserArticleRedeem = (id) => {
  return request({
    url: `/user-article-redeem/${id}`,
    method: 'delete'
  });
};